import React from "react";
//import { Link } from 'react-router-dom';
import { Api } from "./../app-controller.js";
//import { useAuth } from "../components/content/auth.jsx";
import Swal from "sweetalert2";

class Catalogs extends React.Component {
  constructor(props) {
    super(props);

    this.handleTable = this.handleTable.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
    this.handleEditCat = this.handleEditCat.bind(this);
    this.handleTrashCat = this.handleTrashCat.bind(this);
    this.refreshVersion = this.refreshVersion.bind(this);
    this.getVersion = this.getVersion.bind(this);

    this.state = {
      workingGrid: false,
      cat_tables: [],
      nivelUsuario: localStorage.nivel_actual,
      tabla_activa: "",
      tabla: {
        schema: [],
        data: [],
      },
      version: "...",
    };
  }

  componentDidMount() {
    // si el usuario no es nivel administrador ipsa redireccionamos a home
    if (this.state.nivelUsuario !== "2") {
      window.location.href = "/";
    }

    this.cargarCatalogos();
    this.getVersion();
  }

  cargarCatalogos() {
    Api.loading(true);
    Api.fetch("cat/getCatTables").then((r) => {
      this.setState({
        cat_tables: r,
        table_name: "",
      });
      Api.loading(false);
    });
  }
  getVersion() {
    Api.fetch("cat/getVersion", {}, "post").then((r) => {
      this.setState({
        version: r,
      });
    });
  }
  refreshVersion() {
    Api.fetch("cat/syncVersion", {}, "post").then((r) => {
      this.setState({
        version: r,
      });
    });
  }
  handleCreate() {
    let form = "";
    for (let field in this.state.tabla.schema) {
      form +=
        '<input autocomplete="off" id=' +
        this.state.tabla.schema[field].column_name +
        ' placeholder="' +
        this.state.tabla.schema[field].column_name
          .toString()
          .replace("_", " ")
          .toUpperCase() +
        '" class="swal2-input">';
    }

    let form_data = {};
    Swal.fire({
      title: "AGREGAR " + this.state.table_name,
      html: form,
      focusConfirm: false,
      showCancelButton: true,
      cancelButtonText: "Regresar",
      confirmButtonText: "Guardar",
      reverseButtons: true,
      preConfirm: () => {
        for (let field in this.state.tabla.schema) {
          if (
            document.getElementById(this.state.tabla.schema[field].column_name)
              .value === ""
          ) {
            Swal.showValidationMessage("Todos los campos son requeridos.");
          }
          form_data[this.state.tabla.schema[field].column_name] =
            document.getElementById(
              this.state.tabla.schema[field].column_name
            ).value;
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        Api.loading(true);
        Api.fetch(
          "cat/saveTableCat",
          { data: form_data, table: this.state.tabla_activa },
          "POST"
        ).then((r) => {
          this.loadTable(this.state.tabla_activa);
          Api.loading(false);
        });
      }
    });
  }

  handleTable(e) {
    let table = e.target.dataset.table;
    let name = e.target.innerText;
    this.setState({
      tabla_activa: table,
      table_name: name,
    });
    this.loadTable(table);
  }

  loadTable(table) {
    Api.loading(true);
    Api.fetch("cat/getCatTable?table=" + table).then((r) => {
      this.setState({
        tabla: r,
      });
      Api.loading(false);
    });
  }

  handleTrashCat(e) {
    let id = e.target.id;
    let status = e.target.dataset.status;
    let status_text = "";
    let status_desc = "";
    let status_data = "";
    if (status === "1") {
      status_text = "Desactivar";
      status_desc = "Registro desactivado";
      status_data = 0;
    } else {
      status_text = "Reactivar";
      status_desc = "Registro reactivado";
      status_data = 1;
    }

    Swal.fire({
      title: "¿" + status_text + " este registro?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "Regresar",
      confirmButtonText: status_text,
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        Api.loading(true);

        let form_data = {
          status: status_data,
        };
        Api.fetch(
          "cat/updateTableCat",
          { data: form_data, table: this.state.tabla_activa, id: id },
          "POST"
        ).then((r) => {
          this.loadTable(this.state.tabla_activa);
          Api.notify(status_desc);
        });
      }
    });
  }

  handleEditCat(e) {
    let id = e.target.id;

    let form = "";
    for (let field in this.state.tabla.schema) {
      form +=
        '<input autocomplete="off" id=' +
        this.state.tabla.schema[field].column_name +
        ' placeholder="' +
        this.state.tabla.schema[field].column_name
          .toString()
          .replace("_", " ")
          .toUpperCase() +
        '" class="swal2-input">';
    }

    let form_data = {};
    Swal.fire({
      title: "EDITAR " + this.state.table_name,
      html: form,
      focusConfirm: false,
      showCancelButton: true,
      cancelButtonText: "Regresar",
      confirmButtonText: "Actualizar",
      reverseButtons: true,
      preConfirm: () => {
        for (let field in this.state.tabla.schema) {
          if (
            document.getElementById(this.state.tabla.schema[field].column_name)
              .value === ""
          ) {
            Swal.showValidationMessage("Todos los campos son requeridos.");
          }
          form_data[this.state.tabla.schema[field].column_name] =
            document.getElementById(
              this.state.tabla.schema[field].column_name
            ).value;
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        Api.loading(true);
        Api.fetch(
          "cat/updateTableCat",
          { data: form_data, table: this.state.tabla_activa, id: id },
          "POST"
        ).then((r) => {
          this.loadTable(this.state.tabla_activa);
          Api.loading(false);
        });
      }
    });
    Swal.showLoading();
    Api.fetch(
      "cat/getCatData",
      { id: id, table: this.state.tabla_activa },
      "POST"
    ).then((r) => {
      for (let data in r) {
        for (let field in this.state.tabla.schema) {
          if (this.state.tabla.schema[field].column_name === data) {
            document.getElementById(data).value = r[data];
          }
        }
      }
      Swal.hideLoading();
    });
  }

  render() {
    return (
      <div className="row">
        <div className="col-md-3">
          <div className="card">
            <div className="btn-group-vertical">
              <button
                onClick={this.refreshVersion}
                type="button"
                className="btn btn-orange text-right"
              >
                VERSION [{this.state.version}] <i className="fa fa-sync"></i>
              </button>
              {this.state.cat_tables.map((cat) => (
                <button
                  key={cat}
                  onClick={this.handleTable}
                  data-table={cat}
                  type="button"
                  className={
                    this.state.tabla_activa === { cat }
                      ? "active btn btn-purple text-left"
                      : "btn btn-purple text-left"
                  }
                >
                  <i className="fa fa-table"></i>{" "}
                  {cat.replace("cat_", "").replace("_", " ").toUpperCase()}
                </button>
              ))}
            </div>
          </div>
        </div>
        <div className={this.state.tabla_activa !== "" ? "col-md-9" : "hide"}>
          <div className="table-responsive col-md-12">
            <div className="row">
              <div className="col-md-10">
                <h1>{this.state.table_name}</h1>
              </div>
              <div className="col-md-2">
                <button
                  onClick={this.handleCreate}
                  className="btn bg-gradient-blue pull-right"
                >
                  Nuevo <i className="fas fa-plus"></i>
                </button>
              </div>
            </div>
            <table className="table table-striped m-b-0 table-hover">
              <thead>
                <tr>
                  <th>ID</th>
                  {this.state.tabla.schema.map((col) => (
                    <th key={col.column_name}>
                      {col.column_name.toUpperCase()}
                    </th>
                  ))}
                  <th>ESTADO</th>
                  <th>ACCIÓN</th>
                </tr>
              </thead>
              <tbody className={this.state.workingGrid ? "hide" : ""}>
                {this.state.tabla.data.map((row) => (
                  <tr key={`r${row.id}`}>
                    <td>{row.id}</td>
                    {this.state.tabla.schema.map((col) => (
                      <td key={`c${row[col.column_name]}`}>
                        {row[col.column_name]}
                      </td>
                    ))}
                    <td>{row.status === "1" ? "Activo" : "Inactivo"}</td>
                    <td>
                      <div className="btn-group">
                        <button
                          onClick={this.handleEditCat}
                          id={row.id}
                          className="btn bg-gradient-blue"
                        >
                          <i id={row.id} className="fas fa-edit"></i>
                        </button>
                        <button
                          onClick={this.handleTrashCat}
                          id={row.id}
                          data-status={row.status}
                          className={
                            row.status === 1
                              ? "btn bg-gradient-red"
                              : "btn bg-gradient-green"
                          }
                        >
                          <i
                            id={row.id}
                            data-status={row.status}
                            className={
                              row.status === "0"
                                ? "fas fa-trash"
                                : "fas fa-recycle"
                            }
                          ></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className={this.state.workingGrid ? "m-10" : "hide"}>
              <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                CARGANDO INFORMACIÓN
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Catalogs;
